import React from 'react';
import './index.css';
import speaker_on from './images/speaker_on.png';
import speaker_off from './images/speaker_off.png';

export default class Speaker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    this.props.setSound()
  }

  render() {
    return (
        <div>
        {
          this.props.speakerOn === 'on' ? <img id="speaker" src={speaker_on} onClick={() => this.handleClick()} alt="sound on"/> 
          : <img id="speaker" src={speaker_off} onClick={() => this.handleClick()} alt="sound off"/> 
        }
        </div>
    )
  }
}



